import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectors } from 'state';
import { calculateSimplifiedOptionMaxContracts } from '../../../state/app/simplified_options/maxContracts';

export const useSimplifiedOptionMaxContracts = (instrumentId: number) => {
  const session = useSelector(selectors.activeSession);
  const player = useSelector(selectors.player);
  const instrument = useSelector(
    selectors.financialInstrumentById(instrumentId),
  );
  const asset = useSelector(selectors.underlyingAssetOfInstrument(instrument));
  const assetsList = useSelector(selectors.underlyingAssetsList);
  const currenciesList = useSelector(selectors.currenciesList);

  return useMemo(
    () =>
      calculateSimplifiedOptionMaxContracts({
        instrument,
        asset,
        session,
        player,
        assetsList,
        currenciesList,
      }),
    [instrument, asset, session, player, assetsList, currenciesList],
  );
};
